import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00810-input-form q-gutter-y-xs" }
const _hoisted_2 = { class: "row q-gutter-x-sm" }
const _hoisted_3 = { class: "structure-area" }
const _hoisted_4 = { class: "structure-right q-gutter-y-xs" }
const _hoisted_5 = { class: "row q-gutter-x-sm" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row q-gutter-x-sm" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row q-gutter-x-sm" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "row q-gutter-x-sm" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "row q-gutter-x-sm" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "row q-gutter-x-sm" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "row q-gutter-x-sm" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "row q-gutter-x-sm" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "row q-gutter-x-sm" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "cmd00810-button-area row" }
const _hoisted_31 = { class: "col q-gutter-x-xs flex justify-end" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;

import http from '../../common/axios-common';
import { isEmpty, isHalfAlphanumericsymbol } from '../../common/utils/validateUtils';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AtomImage from '../../components/images/AtomImage.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';

// 初期表示データ
interface Props {
  // 商品ID
  molId: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00810',
  props: {
    molId: {}
  },
  setup(__props: any) {

const initData = reactive({
  structure: '',
  atto_id: '',
  id_number: '',
  catalog_id: '',
  cas_number: '',
  mdl: '',
  name1: '',
  name2: '',
  purity: '',
  storage: '',
  hazard_info: '',
  solubility: '',
  target: '',
  memo: '',
  url: '',
  coa: '',
});

const props = __props;

// 更新確認ダイアログ表示
const isConfirmationFlg = ref(false);
// ダイアログ表示
const edit = ref(false);

const router = useRouter();

// ダイアログのtitle
const dialogTitle = ref('');

// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);

// 商品ID
const molId = ref(props.molId);

// MessageChip表示フラグ
const isMessageChip = ref(false);

// エラーメッセージ
const errMessage = ref('');

// 取得したデータ
const updateData = ref({ ...initData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

// 初期表示
const init = () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('molId', molId.value);
  //  初期表示
  http
    .post('/cmd008101/requestDetailGoods', formData)
    .then((response) => {
      const { common, molInfoDto } = response.data;
      switch (common.status) {
        case ResultStatusCode.SUCCESS:
          // 初期表示データ
          Object.assign(initData, molInfoDto);
          initData.cas_number = molInfoDto.cas_number ? molInfoDto.cas_number : '';
          initData.mdl = molInfoDto.mdl ? molInfoDto.mdl : '';
          initData.name1 = molInfoDto.name1 ? molInfoDto.name1 : '';
          initData.name2 = molInfoDto.name2 ? molInfoDto.name2 : '';
          initData.purity = molInfoDto.purity ? molInfoDto.purity : '';
          initData.storage = molInfoDto.storage ? molInfoDto.storage : '';
          initData.hazard_info = molInfoDto.hazard_info ? molInfoDto.hazard_info : '';
          initData.solubility = molInfoDto.solubility ? molInfoDto.solubility : '';
          initData.target = molInfoDto.target ? molInfoDto.target : '';
          initData.memo = molInfoDto.memo ? molInfoDto.memo : '';
          initData.url = molInfoDto.url ? molInfoDto.url : '';
          initData.coa = molInfoDto.coa ? molInfoDto.coa : '';
          // 変更用データ
          updateData.value = molInfoDto;
          updateData.value.cas_number = molInfoDto.cas_number ? molInfoDto.cas_number : '';
          updateData.value.mdl = molInfoDto.mdl ? molInfoDto.mdl : '';
          updateData.value.name1 = molInfoDto.name1 ? molInfoDto.name1 : '';
          updateData.value.name2 = molInfoDto.name2 ? molInfoDto.name2 : '';
          updateData.value.purity = molInfoDto.purity ? molInfoDto.purity : '';
          updateData.value.storage = molInfoDto.storage ? molInfoDto.storage : '';
          updateData.value.hazard_info = molInfoDto.hazard_info ? molInfoDto.hazard_info : '';
          updateData.value.solubility = molInfoDto.solubility ? molInfoDto.solubility : '';
          updateData.value.target = molInfoDto.target ? molInfoDto.target : '';
          updateData.value.memo = molInfoDto.memo ? molInfoDto.memo : '';
          updateData.value.url = molInfoDto.url ? molInfoDto.url : '';
          updateData.value.coa = molInfoDto.coa ? molInfoDto.coa : '';
          break;

        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // 商品情報が存在しない場合
            case DetailResultStatusCode.NOT_MOL_ERROR:
              errMessage.value = response.data.common.message;
              isMessageChip.value = true;
              break;
            default:
              router.push({ name: 'error' });
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 商品情報変更
const updateGoods = async () => {
  isConfirmationFlg.value = false;
  resetErrors();
  // Loading Start
  Loading.show();
  // 変更データ
  const formData = new FormData();
  formData.append('molId', molId.value);
  formData.append('idNumber', updateData.value.id_number);
  formData.append('catalogId', updateData.value.catalog_id);
  formData.append('cas', updateData.value.cas_number);
  formData.append('mdl', updateData.value.mdl);
  formData.append('name1', updateData.value.name1);
  formData.append('name2', updateData.value.name2);
  formData.append('purity', updateData.value.purity);
  formData.append('storage', updateData.value.storage);
  formData.append('hazardInfo', updateData.value.hazard_info);
  formData.append('solubility', updateData.value.solubility);
  formData.append('target', updateData.value.target);
  formData.append('memo', updateData.value.memo);
  formData.append('url', updateData.value.url);
  formData.append('coa', updateData.value.coa);
  // 商品情報変更
  await http
    .post('/cmd008101/updateGoods', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (
          response.data.common.detail_status === DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR
        ) {
          // 重複エラー
          errMessage.value = response.data.common.message;
          isMessageChip.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.UPDATE_ERROR) {
          // 更新エラー
          errMessage.value = response.data.common.message;
          isMessageChip.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.PARAMETER_ERROR) {
          // 単項目チェック
          router.push({ name: 'error' });
        } else {
          // エラー画面遷移
          router.push({ name: 'error' });
        }
      } else {
        // 更新完了
        edit.value = true;
        dialogTitle.value = '更新完了';
        dialogText.value = [response.data.common.message];
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// リセットボタン押下
const reset = () => {
  resetErrors();
  updateData.value = { ...initData };
};

// 戻るボタン押下
const pageBack = () => {
  router.replace({ name: 'catalog' });
};

// 初期表示
// propsが存在しない場合
if (!props.molId) {
  // 前画面に遷移
  pageBack();
} else {
  init();
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[30] || (_cache[30] = [
        _createElementVNode("span", null, "商品情報変更", -1)
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (isConfirmationFlg.value = true), ["prevent"])),
      onReset: reset,
      onValidationError: resetErrors
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[31] || (_cache[31] = _createElementVNode("label", null, "構造式", -1)),
              _createVNode(AtomImage, {
                exatoms: updateData.value.structure,
                style: {"margin-top":"8px","border":"1px solid var(--q-lightColorBorder)","border-radius":"3px"}
              }, null, 8, ["exatoms"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", null, "ATTO_ID", -1)),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(updateData.value.atto_id), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "requier" }, "サプライヤ商品コード", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.id_number,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateData.value.id_number) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area left-input",
                    maxlength: "200",
                    rules: [
                    (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                    (val) => _unref(isHalfAlphanumericsymbol)(val) || _ctx.$t('validation.half_alphanumsymbol'),
                  ],
                    "lazy-rules": "",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", null, "CAS No.", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.cas_number,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateData.value.cas_number) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area left-input",
                    maxlength: "30",
                    rules: [
                    (val) => _unref(isHalfAlphanumericsymbol)(val) || _ctx.$t('validation.half_alphanumsymbol'),
                  ],
                    "lazy-rules": "",
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", null, "MDL", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.mdl,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updateData.value.mdl) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area left-input",
                    maxlength: "30",
                    rules: [
                    (val) => _unref(isHalfAlphanumericsymbol)(val) || _ctx.$t('validation.half_alphanumsymbol'),
                  ],
                    "lazy-rules": "",
                    onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", null, "化学名1", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.name1,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateData.value.name1) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "2000",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", null, "化学名2", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.name2,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updateData.value.name2) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "2000",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", null, "Purity", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.purity,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((updateData.value.purity) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "100",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", null, "Storage", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.storage,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((updateData.value.storage) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "200",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", null, "Hazard Information", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.hazard_info,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((updateData.value.hazard_info) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "200",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", null, "Solubility", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.solubility,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((updateData.value.solubility) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "200",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[17] || (_cache[17] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", null, "Target", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.target,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((updateData.value.target) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "200",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", null, "Supplier_URL", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.url,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((updateData.value.url) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area left-input",
                    maxlength: "300",
                    rules: [
                    (val) => _unref(isHalfAlphanumericsymbol)(val) || _ctx.$t('validation.half_alphanumsymbol'),
                  ],
                    "lazy-rules": "",
                    onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", null, "備考", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.memo,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((updateData.value.memo) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "200",
                    "lazy-rules": "",
                    hint: "",
                    onKeydown: _cache[23] || (_cache[23] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", null, "CoA", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: updateData.value.coa,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((updateData.value.coa) = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "300",
                    "lazy-rules": "",
                    onKeydown: _cache[25] || (_cache[25] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
          "button-area": _withCtx(() => [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_q_btn, {
                color: "grey-7",
                outline: "",
                label: "戻る",
                style: {"min-width":"120px","background":"var(--q-white) !important"},
                onClick: pageBack
              }),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  style: {"width":"150px"},
                  label: "変更",
                  type: "submit"
                }),
                _createVNode(_component_q_btn, {
                  outline: "",
                  style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                  icon: "cached",
                  label: "リセット",
                  onClick: reset
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isConfirmationFlg.value,
      level: "information",
      title: '更新確認',
      text: ['入力された内容で更新します', 'よろしいですか？'],
      onConfirm: _cache[27] || (_cache[27] = ($event: any) => (updateGoods())),
      onClose: _cache[28] || (_cache[28] = ($event: any) => (isConfirmationFlg.value = false))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: edit.value,
      level: "information",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: pageBack,
      onClose: _cache[29] || (_cache[29] = ($event: any) => (edit.value = false))
    }, null, 8, ["display", "title", "text"])
  ]))
}
}

})